import React, { useEffect, useState } from 'react';
import './NotificationBar.css';

const NotificationBar = (props) => {
  const notificationMessage = props.notificationMessage;

  const [visible, setVisible] = useState(false);

  // makes the notification visible.
  useEffect(() => {
    if (notificationMessage?.message) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 15000);
      return () => clearTimeout(timer);
    }
  }, [notificationMessage]);

  // nothing is rendered
  if (!visible) return null;

  // render the notification bar with a Close button
  // × is obtained by pressing the keys Alt + 0215
  return (
    <div className={`NotificationBar NotificationBar-${notificationMessage.className}`}>
      <span>{notificationMessage.message}</span>
      <button className={`NotificationBar-btn NotificationBar-btn-${notificationMessage.className}`} onClick={() => setVisible(false)}>×</button>
    </div>
  );
};

export default NotificationBar;
